import { Route } from '@angular/router';

export const notFoundRoute: Route = {
  path: '**',
  redirectTo: '/notfound',
};
